import { Injectable } from '@angular/core';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { UserLocationService } from '@polaris-customerweb/sharedcomponents.shared';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import {
    GetUserLocation,
    GetUserLocationFail,
    GetUserLocationSuccess,
} from './user-location.actions';

@Injectable()
export class UserLocationEffects {
    getBrowserLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetUserLocation),
            exhaustMap(() =>
                this.userLocationService.getUserLocation().pipe(
                    map((location) => {
                        return GetUserLocationSuccess({ location });
                    }),
                    catchError((errorMessage) => {
                        return of(GetUserLocationFail({ errorMessage }));
                    })
                )
            )
        )
    );

    constructor(
        private readonly actions$: Actions,
        private readonly userLocationService: UserLocationService
    ) {}
}

export const userLocationEffectsModule = EffectsModule.forFeature([
    UserLocationEffects,
]);
